import { FieldProps } from "@/core/components/Field";
import { Box, Card } from "@mui/material";
import React from "react";
import { TextVariant } from "@/core/components/Field/Text";
import {
  AlignItems,
  ButtonVariant,
  HeadingLevel,
  IconPosition,
  MaterialColors,
} from "@/core/types/types";
import NavigationButton from "@/core/components/Field/Buttons/NavigationButton";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

const ReferralProgram = ({ field }: FieldProps) => {

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
        padding: (theme) => `${theme.spacing(3)} ${theme.spacing(2)}`,
        gap: 1,
      }}
    >
      <TextVariant
        text={t("referralprogram.title")}
        variant={HeadingLevel.Body2}
        iconName="Info"
        iconPosition={IconPosition.IconBefore}
        alignItems={AlignItems.FlexStart}
      />
      <Box display="flex" flexDirection="column" ml={4} gap={3} mb={2}>
        <TextVariant
          text={t("referralprogram.text")}
          variant={HeadingLevel.Body2}
        />
      </Box>
      <NavigationButton
        redirectUrl={t("referralprogram.redirectLink")}
        field={{ ...field, properties: { action: undefined } }}
        variant={ButtonVariant.Contained}
        color={MaterialColors.Primary}
        buttonText={t("referralprogram.button")}
      />
    </Card>
  );
};

export default ReferralProgram;
